/**
 * Forward a call to another worker, passing auth context
 *
 * @param {Object} ctx - Request context (contains auth_info)
 * @param {Object} workerClient - Worker client instance
 * @param {string} targetPublicKey - Target worker's public key
 * @param {string} method - Method to call
 * @param {Array} params - Method parameters
 * @param {Object} [options] - Additional call options
 * @returns {Promise<*>} Response from target worker
 */
export const forwardCall = async (
  ctx,
  workerClient,
  targetPublicKey,
  method,
  params,
  options = {},
) => {
  if (!workerClient) {
    throw new Error('WorkerClient not available')
  }

  return workerClient.call(targetPublicKey, method, params, {
    ...options,
    headers: {
      ...ctx.headers,
      ...options.headers,
    },
  })
}

/**
 * Forward a call to another worker by name, passing auth context
 *
 * @param {Object} ctx - Request context (contains auth_info)
 * @param {Object} workerClient - Worker client instance
 * @param {string} workerName - Target worker's name (resolved via namespace service)
 * @param {string} method - Method to call
 * @param {Array} params - Method parameters
 * @param {Object} [options] - Additional call options
 * @returns {Promise<*>} Response from target worker
 */
export const forwardCallByName = async (
  ctx,
  workerClient,
  workerName,
  method,
  params,
  options = {},
) => {
  if (!workerClient) {
    throw new Error('WorkerClient not available')
  }

  return workerClient.callByName(workerName, method, params, {
    ...options,
    headers: {
      ...ctx.headers,
      ...options.headers,
    },
  })
}
